import React, { useEffect, useRef, useState } from 'react'
import { Animated, Dimensions, Easing, Pressable, StyleSheet, View, Text } from 'react-native'
import { WebView } from 'react-native-webview'
import { CloseIcon } from '@components/Icons'
import { colors } from '@lib/colors'

const ANIMATION_DURATION = 250 // ms
const TOP_OFFSET = 50

interface PopupWebviewProps {
  source: string
  visible: boolean
  dismiss: () => void
}

export default function (props: PopupWebviewProps) {
  const { dismiss, source, visible } = props

  const { height } = Dimensions.get('window')
  const [viewPosition, setViewPosition] = useState(0)
  const viewAnimation = useRef(new Animated.Value(0))

  const animateToValue = (value: number) => {
    setViewPosition(value)
    Animated.timing(viewAnimation.current, {
      toValue: value,
      duration: ANIMATION_DURATION,
      useNativeDriver: false,
      easing: Easing.out(Easing.ease),
    }).start()
  }

  useEffect(() => {
    if (visible && viewPosition === 0) {
      animateToValue(1)
      return
    }

    if (!visible && viewPosition === 1) {
      animateToValue(0)
    }
  }, [visible])

  const translateY = viewAnimation?.current.interpolate({
    inputRange: [0, 1],
    outputRange: [height - TOP_OFFSET, 0],
  })

  return (
    <Animated.View style={{
      height: (height - TOP_OFFSET),
      transform: [{ translateY: translateY || 0 }],
      ...styles.container,
    }}>
      <View style={styles.header}>
        <Text style={styles.headerLabel}>Chat</Text>
        <Pressable onPress={dismiss}>
          <CloseIcon color={colors.black} size={25} />
        </Pressable>
      </View>
      <WebView source={{ uri: source }}/>
    </Animated.View>
  )
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: 0,
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    overflow: 'hidden',
    width: '100%',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: colors.white,
    padding: 10,
  },
  headerLabel: {
    flex: 1,
    fontSize: 20,
    textAlign: 'left',
    color: colors.gray[800],
  },
})
